<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-first-aid`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 5a2 2 0 012 2v4h7a2 2 0 012 2v28a2 2 0 01-2 2H6a2 2 0 01-2-2V13a2 2 0 012-2h7V7a2 2 0 012-2h18zm7 10H8v24h32V15zm-15 5a1 1 0 011 1v4h4a1 1 0 011 1v2a1 1 0 01-1 1h-4v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4v-4a1 1 0 011-1h2zm6-11H17v2h14V9z"/></svg>
</template>
<script>

export default {
  name: 'IconFirstAid',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
